<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员中心</el-breadcrumb-item>
      <el-breadcrumb-item>会员退费</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="display:flex;align-items: center">
      <el-input size="mini" placeholder="请输入姓名或手机号进行搜索"
                v-model="customerRequest.queryText"
                @keyup.enter.native="queryReturnPremium()"
                style="width: 200px;"></el-input>
      <el-date-picker
        v-model="customerRequest.selectDate"
        type="daterange"
        range-separator="至"
        size="mini"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="selectKpiData"
        value-format="yyyy-MM-dd"
        style="margin-left: 5px;"
      >
      </el-date-picker>
      <el-select value filterable v-model="selectAreaId" v-if="orgLevel === 1" placeholder="请选择区域" clearable
                 style="margin-left: 5px;width: 200px" size="mini" @change="getArea">
        <el-option
          v-for="item in area"
          :key="item.id"
          :label="item.orgName"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="selectOrgId" clearable value filterable placeholder="请选择门店"
                 style="margin-left: 5px;width: 200px" size="mini" @change="getShop"
                 v-if="orgLevel < 3"
      >
        <el-option
          v-for="org in shop"
          :key="org.id"
          :label="org.orgName"
          :value="org.id">
        </el-option>
      </el-select>
      <el-button size="mini" style="margin-left: 5px;" @click="queryReturnPremium">查询</el-button>
    </div>
    <span style="color: #3a8ee6; font-size: x-small">退费合计：{{tfhj}}元</span>
    <el-table height="510px" :data="returnPremiumList" fit border stripe="stripe"
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                :cell-style="rechargeStateColor"
                :row-style="{height: '0'}">
        <el-table-column
          align="center"
          fixed="fixed"
          label="操作" width="100">
          <template slot-scope="scope">
            <el-link type="danger" :disabled="scope.row.state === 2"
                     v-if="authorities.includes('customer.returnpremium.cancel.yizhi')"
                     icon="iconfont icon-zuofei" @click="cancelReturnPremium(scope.row)"></el-link>
            <el-link type="danger" :disabled="scope.row.state === 2 || nowDate != scope.row.returnDate"
                     v-if="authorities.includes('customer.returnpremium.cancel.today')"
                     icon="iconfont icon-zuofei" @click="cancelReturnPremium(scope.row)"></el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="退费日期"
          align="center"
          width="180">
        </el-table-column>
        <el-table-column
          prop="state"
          label="状态"
          align="center"
          :formatter="returnPremiumStateFormatter">
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="姓名"
          align="center">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机"
          align="center">
        </el-table-column>
        <el-table-column
          prop="money"
          label="退费金额"
          align="center">
        </el-table-column>
        <el-table-column
          prop="refundDiscounts"
          label="退还优惠金额"
          align="center">
        </el-table-column>
        <el-table-column
          prop="orgName"
          label="退费门店"
          align="center">
        </el-table-column>
        <el-table-column
          prop="serverName"
          label="服务人员"
          align="center">
        </el-table-column>
        <el-table-column
          label="备注"
          align="center">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>{{ scope.row.comment }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="mini">{{ scope.row.comment }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 3px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
        </el-pagination>
      </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      returnPremiumList:[],
      authorities:'',
      queryText:'',
      currentOrgId:'',
      currentPage: 1,
      pageSize:20,
      pageTotal:0,
      returnPremiumStateText:[
        {state:1,name:'已退费'},
        {state:2,name:'已作废'}
      ],
      customerRequest:{
        selectDate:'',
        startDate:'',
        endDate:'',
        pageNum:'',
        pageSize:'',
        orgId:'',
        queryText:''
      },
      nowDate:'',
      tfhj:'',
      selectOrgId:'',
      selectAreaId:'',
      area:[],
      shop:[],
    }
  },
  methods:{
    queryReturnPremium(){
      this.loadReturnAmount();
      this.loadReturnPremiumCount();
      this.loadReturnPremium();
    },
    async loadReturnAmount(){
      if (this.selectAreaId !== ''){
        this.customerRequest.areaId  = this.selectAreaId;
      }
      if (this.selectOrgId !== ''){
        this.customerRequest.shopId = this.selectOrgId;
      }
      if (this.customerRequest.selectDate === null || this.customerRequest.selectDate === ''){
        this.customerRequest.startDate = this.getCurrentMonthFirst();
        this.customerRequest.endDate = this.getCurrentMonthLast();
      } else {
        this.customerRequest.startDate = this.customerRequest.selectDate[0];
        this.customerRequest.endDate = this.customerRequest.selectDate[1];
      }
      this.customerRequest.orgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/returnPremium/tfhj`, this.customerRequest)
      this.tfhj = res.data;
    },
    async loadReturnPremiumCount(){
      this.customerRequest.pageNum = this.currentPage;
      this.customerRequest.pageSize = this.pageSize;
      this.customerRequest.orgId = this.currentOrgId;
      if (this.customerRequest.selectDate === null || this.customerRequest.selectDate === ''){
        this.customerRequest.startDate = this.getCurrentMonthFirst();
        this.customerRequest.endDate = this.getCurrentMonthLast();
      } else {
        this.customerRequest.startDate = this.customerRequest.selectDate[0];
        this.customerRequest.endDate = this.customerRequest.selectDate[1];
      }
      const {data:res} = await this.$http.post(`/count/returnPremium`, this.customerRequest)
      this.pageTotal = res.totalPage;
    },
    async loadReturnPremium(){
      this.customerRequest.pageNum = this.currentPage;
      this.customerRequest.pageSize = this.pageSize;
      this.customerRequest.orgId = this.currentOrgId;
      if (this.customerRequest.selectDate === null || this.customerRequest.selectDate === ''){
        this.customerRequest.startDate = this.getCurrentMonthFirst();
        this.customerRequest.endDate = this.getCurrentMonthLast();
      } else {
        this.customerRequest.startDate = this.customerRequest.selectDate[0];
        this.customerRequest.endDate = this.customerRequest.selectDate[1];
      }
      const {data:res} = await this.$http.post(`/query/returnPremium`, this.customerRequest)
      this.returnPremiumList = res.data;
    },
    dataFormatter(row,column){
      let data = row[column.property];
      if(data === null){
        return null;
      }
      let dt = new Date(data);
      return dt.getFullYear() + '-' + (dt.getMonth()+1) + '-' + dt.getDate();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadReturnPremium();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadReturnPremium();
    },
    returnPremiumStateFormatter(row){
      let value = "";
      for (let i = 0; i < this.returnPremiumStateText.length; i++){
        let item = this.returnPremiumStateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    async cancelReturnPremium(data){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/returnPremium/cancel`, data)
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      await this.loadReturnPremium();
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
    },
    rechargeStateColor({row,columnIndex}){
      if (row.state === 1 && columnIndex ===2){
        return 'color:#0CB618';
      } else if (row.state === 2 && columnIndex ===2){
        return 'color:#EA1B28';
      }
    },
    getNowDate() {
      const timeOne = new Date()
      const year = timeOne.getFullYear()
      let month = timeOne.getMonth() + 1
      let day = timeOne.getDate()
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      this.nowDate = `${year}-${month}-${day}`
    },
    selectKpiData(){
      if (this.customerRequest.selectDate === null){
        this.customerRequest.startDate = this.getCurrentMonthFirst();
        this.customerRequest.endDate = this.getCurrentMonthLast();
      } else {
        this.customerRequest.startDate = this.customerRequest.selectDate[0];
        this.customerRequest.endDate = this.customerRequest.selectDate[1];
      }
    },
    getCurrentMonthFirst () {
      let date = new Date()
      date.setDate(1)
      let month = parseInt(date.getMonth() + 1)
      let day = date.getDate()
      if (month < 10) month = '0' + month
      if (day < 10) day = '0' + day
      return date.getFullYear() + '-' + month + '-' + day
    },
    getCurrentMonthLast () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      month = month < 10 ? '0' + month : month
      let day = new Date(year, month, 0)
      return year + '-' + month + '-' + day.getDate()
    },
    async getArea(data){
      if (data === ''){
        this.orderRequest.areaId = '';
      }
      await this.loadShop(data);
    },
    async loadShop(areaId){
      if (areaId !== '' ){
        const {data:res} = await this.$http.get(`/orgs/area/orgId/${areaId}`);
        this.shop = res.data;
      }
      if (areaId === ''){
        this.shop = [];
        this.selectOrgId = '';
      }
    },
    getShop(data){
      this.selectOrgId = data;
      if (data === ''){
        this.orderRequest.shopId = '';
      }
    },
    async loadAreaOrgs(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.currentOrgId}`);
      if (res.code === 200){
        this.area = res.data;
      }
    },
  },
  created() {
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.queryReturnPremium();
    this.loadAreaOrgs();
    if (this.orgLevel > 1){
      this.loadShop(this.currentOrgId);
    }
  }
}
</script>

<style lang="less" scoped>
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
    text-align: center !important;
  }
  /deep/ td {
    padding: 2px ;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ReturnPremium.vue